import * as React from 'react';
import { LightspeedMappingView } from './components';

/**
 * Integrations top-level view. Today: just Lightspeed mapping.
 *
 * Future: when Bolt/Wolt mapping pages move here, add a sub-nav (tabs
 * or a left rail) at this level and wrap the children. For now the
 * single-integration case keeps the page uncluttered.
 */
export const Integrations: React.FC = () => {
  return <LightspeedMappingView />;
};
